import { useState } from "react";
import { AdjustmentsHorizontalIcon, ClipboardDocumentListIcon } from "@heroicons/react/24/outline";
import Tooltip from "../Tooltip";
import PartConditionPickerModal from "./PartConditionPickerModal";
import { ResourceType } from "../../../models/Note";

interface PartConditionPickerButtonProps {
  resourceId: string;
  resourceType: ResourceType;
  refetchQuery?: any[];
}

export default function PartConditionPickerButton({
  resourceId,
  resourceType,
  refetchQuery,
}: PartConditionPickerButtonProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <PartConditionPickerModal
        open={open}
        setOpen={setOpen}
        resourceId={resourceId}
        resourceType={resourceType}
        refetchQuery={refetchQuery}
      />
      <Tooltip content="Quick-add structured condition notes" position="left">
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setOpen(true); }}
          className="p-1 rounded text-gray-400 hover:text-primary-600 hover:bg-primary-50 transition-colors"
        >
          <AdjustmentsHorizontalIcon className="h-5 w-5" />
        </button>
      </Tooltip>
    </>
  );
}
